import { render, staticRenderFns } from "./ShareTableWx.vue?vue&type=template&id=fd34d8ca&scoped=true&lang=html"
import script from "./ShareTableWx.vue?vue&type=script&lang=js"
export * from "./ShareTableWx.vue?vue&type=script&lang=js"
import style0 from "./ShareTableWx.vue?vue&type=style&index=0&id=fd34d8ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd34d8ca",
  null
  
)

export default component.exports